<template>
	<div class="products row">
		<template v-if="foundationDayTemplate">
			<div v-for="(product, index) in businessForm" :key="product.id" class="mb-4 col-12">
				<div class="select-card-new">
					<div class="w-100 d-flex flex-wrap align-items-center">
						<div class="col-12 col-md-7 mb-2 mb-md-0">
							<span>{{ product.name }}</span>
							<FormulateInput
								:id="`products-${product.id}`"
								v-model="selected[product.id]"
								type="hidden"
								:value="Number(index === 0)"
								:options="options"
								:disabled="product.is_hidden === 1"
							/>
						</div>
						<div class="col">
							{{ product.price ? `${ createMaskAmount(product.price) } ₽` : 'Бесплатно' }}
						</div>
						<div class="col d-flex justify-content-end pr-0">
							<b-form-spinbutton
								id="selected-product"
								v-model="selected[product.id]"
								class="select-card-new__input"
								min="0"
								max="10"
								placeholder="0"
								inline
								:disabled="product.is_hidden === 1"
								:class="{ empty: !selected[product.id] }"
								@change="handlerChange"
								@input="handleInput"
							/>
						</div>
					</div>
				</div>
			</div>
			<div v-for="(product) in philanthropyForm" :key="product.id" class="mb-4 col-12">
				<div class="select-card-new lighter">
					<div class="w-100 d-flex flex-wrap align-items-center">
						<div class="col-12 col-md-7 mb-2 mb-md-0">
							<span>{{ product.name }}</span>
							<FormulateInput
								:id="`products-${product.id}`"
								v-model="selected[product.id]"
								type="hidden"
								:value="0"
								:options="options"
								:disabled="product.is_hidden === 1"
							/>
						</div>
						<div class="col">
							{{ product.price ? `${ createMaskAmount(product.price) } ₽` : 'Бесплатно' }}
						</div>
						<div class="col d-flex justify-content-end pr-0">
							<b-form-spinbutton
								id="selected-product"
								v-model="selected[product.id]"
								class="select-card-new__input"
								min="0"
								max="10"
								placeholder="0"
								inline
								:disabled="product.is_hidden === 1"
								:class="{ empty: !selected[product.id] }"
								@change="handlerChange"
								@input="handleInput"
							/>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div v-for="(product, index) in productsForForm" :key="product.id" class="mb-4 col-12">
				<div class="select-card-new">
					<div class="w-100 d-flex flex-wrap align-items-center">
						<div class="col-12 col-md-7 mb-2 mb-md-0">
							<span>{{ product.name }}</span>
							<FormulateInput
								:id="`products-${product.id}`"
								v-model="selected[product.id]"
								type="hidden"
								:value="Number(index === 0 && product.id !== 4535)"
								:options="options"
								:disabled="product.is_hidden === 1"
							/>
						</div>
						<div class="col">
							{{ product.price ? `${ createMaskAmount(product.price) } ₽` : 'Бесплатно' }}
						</div>
						<div class="col d-flex justify-content-end pr-0">
							<b-form-spinbutton
								id="selected-product"
								v-model="selected[product.id]"
								class="select-card-new__input"
								min="0"
								max="10"
								placeholder="0"
								inline
								:disabled="product.is_hidden === 1"
								:class="{ empty: !selected[product.id] }"
								@change="handlerChange"
								@input="handleInput"
							/>
						</div>
					</div>
				</div>
			</div>
		</template>
		<div v-if="isShowChildAge" class="mb-4 col-12 col-lg-6">
			<FormulateInput
				v-if="selected[1095] > 1"
				id="childsAge"
				v-model="childsAge"
				element-class="d-flex flex-row"
				input-class="mr-2"
				name="childsAge"
				:options="optionsChildAge"
				placeholder="Выберите возрастную категорию"
				type="checkbox"
				label="Возрастная категория детей"
				validation="required"
				:validation-messages="{
					required: 'Выберите значение'
				}"
				@change="($event) => handlerChangeChildsAge($event.target.value)"
			/>
			<FormulateInput
				v-else
				id="childsAge"
				v-model="childsAge"
				element-class="d-flex flex-row"
				input-class="mr-2"
				name="childsAge"
				:options="optionsChildAge"
				placeholder="Выберите возрастную категорию"
				type="checkbox"
				label="Возрастная категория детей"
				validation="bail|required|onlyOneValue"
				:validation-rules="{
					onlyOneValue: ({ value }) => value.length === 1
				}"
				:validation-messages="{
					required: 'Выберите значение',
					onlyOneValue: 'Выберите только одну категорию'
				}"
				@change="($event) => handlerChangeChildsAge($event.target.value)"
			/>
		</div>
	</div>
</template>

<script>
// import formulateFormScenario from "~/mixins/formulateFormScenario";
import { createMaskAmount } from '~/utils/intl-converter';

export default {
	name: 'ProductWithCountTypeNew',
	props: {
		products: {
			type: Array,
			required: true,
		},
		title: {
			type: String,
			default: 'Выберите значение',
		},
		productKey: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			selected: {},
			productsForForm: [],
			businessForm: [],
			philanthropyForm: [],
			nameLabel: 'Выберите количество билетов',
			options: [
				{ value: 'Выберите количество', label: 'Выберите количество' },
				{ value: 1, label: '1' },
				{ value: 2, label: '2' },
				{ value: 3, label: '3' },
				{ value: 4, label: '4' },
				{ value: 5, label: '5' },
				{ value: 6, label: '6' },
				{ value: 7, label: '7' },
				{ value: 8, label: '8' },
				{ value: 9, label: '9' },
				{ value: 10, label: '10' },
			],
			isShowChildAge: false,
			optionsChildAge: [
				{ value: '3-12', label: '3-12' },
				{ value: '12-18', label: '12-18' },
			],
			childsAge: null,
			isRequiredValidation: true,
		};
	},
	computed: {
		productsWithCount() {
			const productsArray = [];
			// eslint-disable-next-line no-restricted-syntax
			for (const [key, value] of Object.entries(this.selected)) {
				const product = this.products.find((item) => item.id === +key);
				productsArray.push({
					id: key,
					quantity: value,
					price: product?.price,
					discount_price: product?.discount_price,
					price_without_vat: product?.price_without_vat,
				});
			}
			return productsArray;
		},
		foundationDayTemplate() {
			return this.businessForm.length && this.philanthropyForm.length;
		},
	},
	watch: {
		products: {
			handler(newProducts) {
				this.selected = {};
				const products = [];
				newProducts.forEach((product) => {
					if (product) {
						products.push({
							id: product.id,
							name: product.name,
							price: product.price,
							discount_price: product.discount_price,
							price_without_vat: product.price_without_vat,
							is_hidden: product.is_hidden,
						});
					}
				});
				this.productsForForm = products;
				this.businessForm = products.filter((product) => product.id === 6845 || product.id === 745);
				this.philanthropyForm = products.filter((product) => product.id === 6865 || product.id === 6895);
				// this.handlerChange();
			},
			immediate: true,
		},
		selected: {
			handler(value) {
				if (Number.isNaN(parseInt(value[1095], 10))) {
					this.isShowChildAge = false;
					this.childsAge = null;
				} else {
					this.isShowChildAge = true;
				}
			},
			deep: true,
		},
	},
	mounted() {
		this.products.forEach((product) => {
			if (product.is_hidden === 1) {
				this.$set(this.selected, product.id, '1');
				this.isRequiredValidation = false;
			}
		});
		this.handlerChange(this.productsWithCount);
	},
	beforeDestroy() {
		this.$emit('handlerChange', []);
	},
	methods: {
		createMaskAmount,
		handleInput() {
			this.$emit('input', {
				products: this.productsWithCount,
			});
		},
		handlerChange() {
			this.$emit('handlerChange', this.productsWithCount);
		},
		handlerChangeChildsAge(value) {
			this.$emit('handlerChangeChildsAge', value);
		},
	},
};
</script>
<style lang="scss">
@import 'assets/styles/sk_variables';
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";

.select-card-new {
	background-color: $theme-lightblue;
	padding: .5rem;
	min-height: 5.5rem;
	display: flex;
	align-items: center;

	&.lighter {
		background-color: $theme-light;
	}

	@media (max-width: map-get($grid-breakpoints, md)) {
		min-height: 7rem;
	}

	&__input.form-control {
		border: none;

		&.empty {
			button {
				&[aria-label="Decrement"] {
					color: $border-color;
					background-color: unset;
					pointer-events: none;
					border: 1px solid $border-color !important;
				}
			}
		}

		output {
			border: none !important;
		}

		button {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 1.9rem;
			height: 1.9rem;
			border-radius: 50% !important;
			background-color: $primary;
			color: $white;
		}
	}

	&__badge {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 50%;
		background-color: $blue;
		color: $white;
	}
}

.formulate-input-element.formulate-input-element--select.my-element-class {
	& > select {
		border: none !important;
		background: $theme-lightblue;
		border-radius: 1rem !important;
	}
}

.b-form-spinbutton.form-control {
	padding-right: .75rem !important;
}
</style>
